import React from 'react';

const PolicyPage: React.FC = () => {
  return (
    <>
      {/* Main Title */}
      <div style={{ textAlign: 'center', marginBottom: '48px' }}>
        <h1 style={{ 
          fontSize: '32px', 
          fontWeight: 'bold', 
          color: '#374151', 
          marginBottom: '16px',
          fontFamily: '"Lato", sans-serif'
        }}>
          Privacy Policy
        </h1>
      </div>

      {/* Content Container */}
      <div style={{
        maxWidth: '900px',
        margin: '0 auto',
        padding: '0 24px 64px 24px'
      }}>
        {/* Introduction */}
        <div style={{ marginBottom: '48px' }}>
          <p style={{
            color: '#6b7280',
            fontSize: '16px',
            lineHeight: '1.6',
            fontFamily: '"Lato", sans-serif',
            marginBottom: '16px'
          }}>
            Rambha Palace, a unit of Suave Ventures Private Limited, having its registered office in India ("Rambha Palace", "we", "us", or "our"), is committed to protecting the privacy and personal information of users visiting www.rambhapalace.com ("Website").
          </p>
          <p style={{
            color: '#6b7280',
            fontSize: '16px',
            lineHeight: '1.6',
            fontFamily: '"Lato", sans-serif'
          }}>
            This Privacy Policy is framed in accordance with the Information Technology Act, 2000, and the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011, and other applicable Indian laws.
          </p>
        </div>

        {/* Section 1: Information We Collect */}
        <div style={{ marginBottom: '48px' }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#374151',
            marginBottom: '24px',
            fontFamily: '"Lato", sans-serif'
          }}>
            1. Information We Collect
          </h2>
          <p style={{
            color: '#6b7280',
            fontSize: '16px',
            lineHeight: '1.6',
            fontFamily: '"Lato", sans-serif',
            marginBottom: '16px'
          }}>
            We may collect the following personal information when you interact with our Website, including through the Contact page:
          </p>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0
          }}>
            <li style={{
              marginBottom: '12px',
              color: '#6b7280',
              fontSize: '16px',
              lineHeight: '1.6',
              fontFamily: '"Lato", sans-serif',
              paddingLeft: '24px',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: 0,
                color: '#374151'
              }}>•</span>
              Name
            </li>
            <li style={{
              marginBottom: '12px',
              color: '#6b7280',
              fontSize: '16px',
              lineHeight: '1.6',
              fontFamily: '"Lato", sans-serif',
              paddingLeft: '24px',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: 0,
                color: '#374151'
              }}>•</span>
              Email address
            </li>
            <li style={{
              marginBottom: '12px',
              color: '#6b7280',
              fontSize: '16px',
              lineHeight: '1.6',
              fontFamily: '"Lato", sans-serif',
              paddingLeft: '24px',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: 0,
                color: '#374151'
              }}>•</span>
              Phone number
            </li>
            <li style={{
              marginBottom: '12px',
              color: '#6b7280',
              fontSize: '16px',
              lineHeight: '1.6',
              fontFamily: '"Lato", sans-serif',
              paddingLeft: '24px',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: 0,
                color: '#374151'
              }}>•</span>
              Message or inquiry details
            </li>
            <li style={{
              marginBottom: '12px',
              color: '#6b7280',
              fontSize: '16px',
              lineHeight: '1.6',
              fontFamily: '"Lato", sans-serif',
              paddingLeft: '24px',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: 0,
                color: '#374151'
              }}>•</span>
              IP address and browser details (for security and analytics)
            </li>
          </ul>
          <p style={{
            color: '#6b7280',
            fontSize: '16px',
            lineHeight: '1.6',
            fontFamily: '"Lato", sans-serif',
            marginTop: '16px'
          }}>
            We do not knowingly collect sensitive personal data unless required for booking or legal compliance.
          </p>
        </div>

        {/* Section 2: Purpose of Collection */}
        <div style={{ marginBottom: '48px' }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#374151',
            marginBottom: '24px',
            fontFamily: '"Lato", sans-serif'
          }}>
            2. Purpose of Collection
          </h2>
          <p style={{
            color: '#6b7280',
            fontSize: '16px',
            lineHeight: '1.6',
            fontFamily: '"Lato", sans-serif',
            marginBottom: '16px'
          }}>
            Your information is collected and used solely for the following purposes:
          </p>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0
          }}>
            <li style={{
              marginBottom: '12px',
              color: '#6b7280',
              fontSize: '16px',
              lineHeight: '1.6',
              fontFamily: '"Lato", sans-serif',
              paddingLeft: '24px',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: 0,
                color: '#374151'
              }}>•</span>
              Responding to inquiries and communication requests
            </li>
            <li style={{
              marginBottom: '12px',
              color: '#6b7280',
              fontSize: '16px',
              lineHeight: '1.6',
              fontFamily: '"Lato", sans-serif',
              paddingLeft: '24px',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: 0,
                color: '#374151'
              }}>•</span>
              Processing booking-related queries
            </li>
            <li style={{
              marginBottom: '12px',
              color: '#6b7280',
              fontSize: '16px',
              lineHeight: '1.6',
              fontFamily: '"Lato", sans-serif',
              paddingLeft: '24px',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: 0,
                color: '#374151'
              }}>•</span>
              Providing customer support
            </li>
            <li style={{
              marginBottom: '12px',
              color: '#6b7280',
              fontSize: '16px',
              lineHeight: '1.6',
              fontFamily: '"Lato", sans-serif',
              paddingLeft: '24px',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: 0,
                color: '#374151'
              }}>•</span>
              Internal record keeping and compliance
            </li>
            <li style={{
              marginBottom: '12px',
              color: '#6b7280',
              fontSize: '16px',
              lineHeight: '1.6',
              fontFamily: '"Lato", sans-serif',
              paddingLeft: '24px',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: 0,
                color: '#374151'
              }}>•</span>
              Improving our services and website experience
            </li>
          </ul>
        </div>

        {/* Section 3: Cookies and Tracking */}
        <div style={{ marginBottom: '48px' }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#374151',
            marginBottom: '24px',
            fontFamily: '"Lato", sans-serif'
          }}>
            3. Cookies and Tracking
          </h2>
          <p style={{
            color: '#6b7280',
            fontSize: '16px',
            lineHeight: '1.6',
            fontFamily: '"Lato", sans-serif'
          }}>
            Our Website may use cookies to enhance user experience and analyze traffic. Cookies do not collect personally identifiable information unless voluntarily provided by you. You may disable cookies through your browser settings.
          </p>
        </div>

        {/* Section 4: Disclosure of Information */}
        <div style={{ marginBottom: '48px' }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#374151',
            marginBottom: '24px',
            fontFamily: '"Lato", sans-serif'
          }}>
            4. Disclosure of Information
          </h2>
          <p style={{
            color: '#6b7280',
            fontSize: '16px',
            lineHeight: '1.6',
            fontFamily: '"Lato", sans-serif',
            marginBottom: '16px'
          }}>
            We do not sell, trade, or rent your personal data to third parties.
          </p>
          <p style={{
            color: '#6b7280',
            fontSize: '16px',
            lineHeight: '1.6',
            fontFamily: '"Lato", sans-serif',
            marginBottom: '16px'
          }}>
            Information may be disclosed only:
          </p>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0
          }}>
            <li style={{
              marginBottom: '12px',
              color: '#6b7280',
              fontSize: '16px',
              lineHeight: '1.6',
              fontFamily: '"Lato", sans-serif',
              paddingLeft: '24px',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: 0,
                color: '#374151'
              }}>•</span>
              To comply with legal obligations or court orders
            </li>
            <li style={{
              marginBottom: '12px',
              color: '#6b7280',
              fontSize: '16px',
              lineHeight: '1.6',
              fontFamily: '"Lato", sans-serif',
              paddingLeft: '24px',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: 0,
                color: '#374151'
              }}>•</span>
              To government authorities as required under applicable law
            </li>
            <li style={{
              marginBottom: '12px',
              color: '#6b7280',
              fontSize: '16px',
              lineHeight: '1.6',
              fontFamily: '"Lato", sans-serif',
              paddingLeft: '24px',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: 0,
                color: '#374151'
              }}>•</span>
              To trusted service providers strictly for operational purposes, under confidentiality obligations
            </li>
          </ul>
        </div>

        {/* Section 5: Data Retention */}
        <div style={{ marginBottom: '48px' }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#374151',
            marginBottom: '24px',
            fontFamily: '"Lato", sans-serif'
          }}>
            5. Data Retention
          </h2>
          <p style={{
            color: '#6b7280',
            fontSize: '16px',
            lineHeight: '1.6',
            fontFamily: '"Lato", sans-serif'
          }}>
            Personal information is retained only for as long as necessary to fulfil the purpose for which it was collected or as required under applicable Indian laws.
          </p>
        </div>

        {/* Section 6: Data Security */}
        <div style={{ marginBottom: '48px' }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#374151',
            marginBottom: '24px',
            fontFamily: '"Lato", sans-serif'
          }}>
            6. Data Security
          </h2>
          <p style={{
            color: '#6b7280',
            fontSize: '16px',
            lineHeight: '1.6',
            fontFamily: '"Lato", sans-serif'
          }}>
            We implement reasonable security practices and procedures to safeguard your personal data against unauthorized access, misuse, alteration, or disclosure.
          </p>
        </div>

        {/* Section 7: User Rights */}
        <div style={{ marginBottom: '48px' }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#374151',
            marginBottom: '24px',
            fontFamily: '"Lato", sans-serif'
          }}>
            7. User Rights
          </h2>
          <p style={{
            color: '#6b7280',
            fontSize: '16px',
            lineHeight: '1.6',
            fontFamily: '"Lato", sans-serif',
            marginBottom: '16px'
          }}>
            You have the right to:
          </p>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0
          }}>
            <li style={{
              marginBottom: '12px',
              color: '#6b7280',
              fontSize: '16px',
              lineHeight: '1.6',
              fontFamily: '"Lato", sans-serif',
              paddingLeft: '24px',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: 0,
                color: '#374151'
              }}>•</span>
              Review the personal data provided by you
            </li>
            <li style={{
              marginBottom: '12px',
              color: '#6b7280',
              fontSize: '16px',
              lineHeight: '1.6',
              fontFamily: '"Lato", sans-serif',
              paddingLeft: '24px',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: 0,
                color: '#374151'
              }}>•</span>
              Request correction or deletion of your personal data (subject to legal obligations)
            </li>
          </ul>
          <p style={{
            color: '#6b7280',
            fontSize: '16px',
            lineHeight: '1.6',
            fontFamily: '"Lato", sans-serif',
            marginTop: '16px'
          }}>
            Requests may be sent to the contact details provided below.
          </p>
        </div>

        {/* Section 8: Third-Party Links */}
        <div style={{ marginBottom: '48px' }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#374151',
            marginBottom: '24px',
            fontFamily: '"Lato", sans-serif'
          }}>
            8. Third-Party Links
          </h2>
          <p style={{
            color: '#6b7280',
            fontSize: '16px',
            lineHeight: '1.6',
            fontFamily: '"Lato", sans-serif'
          }}>
            Our Website may contain links to third-party websites. We are not responsible for the privacy practices or content of such websites.
          </p>
        </div>

        {/* Section 9: Policy Updates */}
        <div style={{ marginBottom: '48px' }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#374151',
            marginBottom: '24px',
            fontFamily: '"Lato", sans-serif'
          }}>
            9. Policy Updates
          </h2>
          <p style={{
            color: '#6b7280',
            fontSize: '16px',
            lineHeight: '1.6',
            fontFamily: '"Lato", sans-serif'
          }}>
            We reserve the right to update this Privacy Policy at any time. Changes shall be effective upon posting on the Website.
          </p>
        </div>
      </div>
    </>
  );
};

export default PolicyPage;

